export const GET_ALL_RECIPES = 'GET_ALL_RECIPES'
export const GET_RECIPES_BY_TITLE = 'GET_RECIPES_BY_TITLE'
export const GET_DIETS = 'GET_DIETS'
export const ADD_RECIPE = 'ADD_RECIPE'
export const FILTER_BY_DIETS = 'FILTER_BY_DIETS'
export const ORDER_RECIPES = 'ORDER_RECIPES'
export const GET_RECIPE_BY_DETAIL = 'GET_RECIPE_BY_DETAIL'
export const LOADING = 'LOADING'
export const ERROR = 'ERROR'